import React from "react";
import styles from "./Table.module.scss";
import { StatusBadge, StatusBadgeVariant } from "@bale/ui";
import { digitsToHindi } from "@bale/utils";

export type CellType = {
  text: string;
  badge?: string;
};

export type TableType = {
  headers: {
    splitter?: string;
    vertical?: string[];
    horizontal?: string[];
  };
  data: CellType[][];
};

interface Props {
  table: TableType;
}

const Table = ({ table }: Props) => {
  return (
    <table className={styles.table}>
      {table.headers.horizontal && (
        <thead>
          <tr>
            {table.headers.splitter && (
              <th className={styles.headerCell} key="splitter">
                {table.headers.splitter}
              </th>
            )}
            {table.headers.horizontal.map((header, index) => (
              <th
                className={`${styles.headerCell} ${table.headers.horizontal && table.headers.horizontal.length > 1 ? undefined : styles.special}`}
                key={index}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {table.data.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {table.headers.vertical && (
              <td className={styles.headerCell}>
                {table.headers.vertical[rowIndex]}
              </td>
            )}
            {row.map((cell, cellIndex) => (
              <td
                key={cellIndex}
                className={row.length > 1 ? undefined : styles.special}
              >
                <div className={styles.content}>
                  {digitsToHindi(cell.text)}
                  {cell.badge && (
                    <StatusBadge
                      text={cell.badge}
                      variant={StatusBadgeVariant.SMALL}
                    />
                  )}
                </div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default Table;
